import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const SanctionRevenueBreakDownApi = (data) => {
    return API.post(`${URL.GET_ALL_SANCTION_REVENUE_BREAK_DOWN_LIST}`, data.body, { params: data?.params })
}
export const SanctionMemberListRevenueBreakDownApi = (data) => {
    return API.post(`${URL.GET_ALL_SANCTION_MEMBER_LIST_REVENUE_BREAK_DOWN_LIST}`, data?.body, {
        params: data?.params
    })
}

export const SanctionPlanListRevenueBreakDownApi = (data) => {
    return API.post(`${URL.SANCTION_PLAN_LIST_REVENUE_BREAK_DOWN_LIST}`, data?.body, {
        params: data?.params
    })
}

export const SanctionRevenueBreakDownGrandTotalApi = (data) =>
    API.get(`${URL.SANCTION_REVENUE_BREAK_DOWN_GRAND_TOTAL}`, data?.params)

export const SanctionRevenueBreakDownExportToCsvApi = (data) => {
    return API.post(`${URL.SANCTION_REVENUE_BREAK_DOWN_EXPORT_TO_CSV}`, data.bodyData, {
        params: data?.params
    })
}
